module.exports = __webpack_public_path__ + "static/media/volkswagen.2c386569.png";